import { useEffect } from 'react';
import type React from 'react';

import { useGoogleOneTapLogin } from 'src/app/pages/loginOrSignup/shared/hooks';
import { useFocusFallbackRef } from 'src/app/shared/hooks/focus';

import { LoginOrSignupBanner } from '../components/LoginOrSignupBanner';
import { LoginOrSignupBody } from '../components/LoginOrSignupBody';
import { LoginOrSignupFooter } from '../components/LoginOrSignupFooter';
import { LoginOrSignupHeader } from '../components/LoginOrSignupHeader';

import { useTrackLoginOrSingupPageView } from './hooks/useTrackLoginOrSingupPageView';

export const LoginOrSignupLayout: React.FC = () => {
	useTrackLoginOrSingupPageView();

	const ref = useFocusFallbackRef();

	const { displayGoogleOneTap } = useGoogleOneTapLogin({});

	useEffect(() => {
		displayGoogleOneTap();
	}, [displayGoogleOneTap]);

	return (
		<>
			<LoginOrSignupBanner />
			<div ref={ref}>
				{/* 60px+1px+40px refers to HEADER_HEIGHT+line+heading margin, but tailwind doesn't support calc with imported constants
				FIXME use a CSS variable maybe? */}
				<div className="container min-h-[calc(100vh-101px)]">
					<div className="mx-auto md:w-96">
						<div className="mt-10 md:mt-16">
							<LoginOrSignupHeader />
						</div>
						<div className="my-6">
							<LoginOrSignupBody />
						</div>
						<LoginOrSignupFooter />
					</div>
				</div>
			</div>
		</>
	);
};
